import { transport } from 'config/transport';

export function callApiDeleteClass(classId) {
    return transport.del(`/mamnon/classes/${classId}`);
}
